<script lang="ts">
  import { domId } from "../../../lib/dom";
  import CloseButton from "../../../components/CloseButton.svelte";
  import { type Component } from "svelte";

  let {
    answer,
    back,
    inactive,
    clientAddress,
    clientAddressIncomplete,
    financeAgreementStartDateLocalized,
    nextStep,
  }: {
    answer: ({ nextStep, status }) => void;
    back: () => void;
    inactive: boolean;
    clientAddress: { [key: string]: string };
    clientAddressIncomplete: boolean;
    financeAgreementStartDateLocalized: string;
    nextStep: Component;
  } = $props();

  let streetInput = $state(clientAddress.street || "");
  let cityInput = $state(clientAddress.city || "");
  let postalCodeInput = $state(clientAddress.postal_code || "");
  let errors = $state([]);
  let addressUnchanged = $derived(
    clientAddress.street === streetInput &&
    clientAddress.city === cityInput &&
    clientAddress.postal_code === postalCodeInput
  );
  let addressUnchangedAndComplete = $derived(addressUnchanged && !clientAddressIncomplete);

  // The fallback account address is not considered new information, only the user
  // making an actual change to the form input fields counts as status "changed"
  function handleContinue() {
    confirmNameInput();
    if (errors.length === 0) {
      answer({ nextStep, status: addressUnchanged ? "unchanged" : "changed" });
    }
  }

  function confirmNameInput() {
    errors = [];
    if (streetInput === "") {
      errors.push("Street name & number is required");
    }
    if (cityInput === "") {
      errors.push("Town/City is required");
    }
    if (postalCodeInput === "") {
      errors.push("Postal code is required");
    }
    // Don't require address to change when incomplete (due to fallback on account address)
    if (addressUnchangedAndComplete) {
      errors.push("Please enter a different address from the original one you provided");
    }
  }

  const streetId = domId("street");
  const cityId = domId("city");
  const postalCodeId = domId("postal_code");
</script>

<div class="h-full">
  <fieldset class="ui-fieldset">
    <legend>
      <span>At which address did you live on <b>{financeAgreementStartDateLocalized}</b>?</span>
    </legend>

    {#if !addressUnchangedAndComplete}
      <input
        type="hidden"
        name="client_address[status]"
        value="changed"
      />
    {/if}

    <fieldset class="ui-fieldset">
      <legend>Street Name & Number</legend>
      <input
        id={streetId}
        type="text"
        name="client_address[street]"
        class="input input-bordered w-full"
        bind:value={streetInput}
      />
    </fieldset>

    <fieldset class="ui-fieldset">
      <legend>Town/City</legend>
      <input
        id={cityId}
        type="text"
        name="client_address[city]"
        class="input input-bordered w-full"
        bind:value={cityInput}
      />
    </fieldset>

    <fieldset class="ui-fieldset">
      <legend>Postal Code</legend>
      <input
        id={postalCodeId}
        type="text"
        name="client_address[postal_code]"
        class="input input-bordered w-full"
        bind:value={postalCodeInput}
      />
    </fieldset>

    {#if errors.length > 0}
      <div class="ui-error">{errors.join(". ")}</div>
    {/if}
  </fieldset>
</div>

<div class="floating-footer">
  {#if back}
    <button type="button" class="btn btn-ghost" onclick={back}>Back</button>
  {:else}
    <CloseButton />
  {/if}
  <button type="submit" class="btn btn-primary" onclick={handleContinue} disabled={inactive}>Continue</button>
</div>
